export const RN_BROADCAST_ONBOARDING_WIZARD_MODAL = 'RN_BROADCAST_ONBOARDING_WIZARD_MODAL'

export enum RnListName {
  MESSENGER_LIST = 'Messenger List',
  INSTAGRAM_DM_LIST = 'Instagram DM List',
}
